<style lang="less">
  @import "~@/public/less/index.less";
  .fan-search{
    .arco-form{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 4px;
    }
    .arco-form-item{
      width: auto; margin: 0 !important; padding: 0 !important;
      display: flex;
      align-items: center;
    }
    .arco-form { padding: 0 !important; }
    :deep(.arco-select-view-single){
      width: 150px !important;
      min-width: 0 !important;
      max-width: 150px !important;
    }
    :deep(.arco-select-view-single .arco-select-view-input){
      min-width: 0;
    }
    .btn-group{
      display: inline-flex;
      align-items: center;
      gap: 6px;
      white-space: nowrap;
      flex-shrink: 0;
    }
    .search-input { width: 120px; }
    .search-date { width: 140px; }
  }
</style>

<template>
  <div class="fan fan-component fan-search">
    <a-form :model="filter" layout="inline">
      <template v-for="(column, field, idx) in columns" :key="field">
        <template v-if="!(idx >= maxVisible && !expanded && showExpand)">
        <a-form-item v-if="column.search && column.form==='cascader'">
          <a-cascader :allow-clear="false"
                      :options="options[field]"
                      :placeholder="column.title"
                      :filterable="true"
                      expand-trigger="hover"
                      :change-on-select="true"
                      v-model="filter[field]"/>
        </a-form-item>
        <a-form-item v-else-if="column.search && (column.form==='select' || column.form==='radio')" :class="{ 'search-extra': field in searchExtras }">
          <a-select style="width: 182px; min-width: 100px"
                    class="select"
                    allow-clear
                    allow-search
                    :placeholder="(options[field] && options[field].length) ? column.title : '加载中...'"
                    v-model="filter[field]" >
            <a-option v-for="opt in (options[field] || [])" :key="opt.value" :value="opt.value">{{opt.label}}</a-option>
          </a-select>
        </a-form-item>
        <a-form-item v-else-if="column.search && column.form==='linkSelect'" :class="{ 'search-extra': field in searchExtras }">
          <div style="display:flex;align-items:center;gap:20px">
            <a-select style="width:182px" allow-clear allow-search
                      :placeholder="column.title"
                      v-model="filter[field]"
                      @change="onLinkSearchChange(field, $event)">
              <a-option v-for="opt in (flatOptions(field)||[])" :key="opt.value" :value="opt.value">{{ opt.label }}</a-option>
            </a-select>
            <!-- <span style="color:#86909c;flex-shrink:0">/</span> -->
            <a-select style="width:182px" allow-clear allow-search
                      :key="'link2_' + field + '_' + (filter[field] || '')"
                      :placeholder="column.linkPlaceholder || '请选择'"
                      v-model="filter['_link_' + field]"
                      :disabled="!filter[field]">
              <a-option v-for="opt in (_linkChildOpts[field]||[])" :key="opt.value" :value="opt.value">{{ opt.label }}</a-option>
            </a-select>
          </div>
        </a-form-item>
        <a-form-item v-else-if="column.search && column.form==='selectTree'" :class="{ 'search-extra': field in searchExtras }">
          <a-tree-select class="select2"
                         allow-clear
                         filter-tree-node
                         :data="treeSelectData(field)"
                         :placeholder="column.title"
                         v-model="filter[field]"
                         default-expand-all />
        </a-form-item>
        <a-form-item v-else-if="column.search && (column.form==='input' || column.form==='textarea' || column.form==='editor')" :class="{ 'search-extra': field in searchExtras }">
          <a-input :placeholder="column.title" v-model="filter[field]" />
        </a-form-item>
        <!--小数（decimal）-->
        <a-form-item v-else-if="column.search && column.form==='decimal'" :class="{ 'search-extra': field in searchExtras }">
          <a-input-number :placeholder="column.placeholder || column.title"
                          :min="0" :step="0.1"
                          style="width: 150px"
                          allow-clear
                          v-model="filter[field]" />
        </a-form-item>
         <!--年选择-->
        <a-form-item v-else-if="column.search && column.form==='yearpicker'" :class="{ 'search-extra': field in searchExtras }">
          <a-date-picker :placeholder="column.title" v-model="filter[field]" format="YYYY" mode="year" style="width: 182px;" :allow-clear="false" />
        </a-form-item>
        <!--日期选择-->
        <a-form-item v-else-if="column.search && column.form==='datepicker'" :class="{ 'search-extra': field in searchExtras }">
          <a-date-picker :placeholder="column.title" v-model="filter[field]" format="YYYY-MM-DD" style="width: 182px;" :allow-clear="false" />
        </a-form-item>
        <!--月份选择-->
        <a-form-item v-else-if="column.search && column.form==='monthpicker'" :class="{ 'search-extra': field in searchExtras }">
          <a-date-picker :placeholder="column.title" v-model="filter[field]" format="YYYY-MM" mode="month" style="width: 182px;" :allow-clear="false" />
        </a-form-item>
        <a-form-item v-else-if="column.scopedSlots&&column.scopedSlots.customRender==='apply_states'" :class="{ 'search-extra': field in searchExtras }">
          <a-select style="width: 180px" class="select" allow-clear :placeholder="column.title" v-model="filter[field]">
            <a-option :value="0" label="待审">待审</a-option>
            <a-option :value="1" label="复审">复审</a-option>
            <a-option :value="2" label="通过">通过</a-option>
            <a-option :value="3" label="驳回">驳回</a-option>
          </a-select>
        </a-form-item>
        <a-form-item v-else-if="column.search">
          未定义检索类型:{{column.form}}
        </a-form-item>
        </template>
      </template>
      <div class="btn-group">
        <a-button v-if="showExpand" size="small" type="text" @click="toggleExpand">
          <!-- {{ expanded ? '收起' : '展开' }} -->
          <component :is="expanded ? 'icon-up' : 'icon-down'" />
        </a-button>
        <a-button type="primary" size="small" status="normal" @click="bindSubmit"><icon-search />筛选</a-button>
        <a-button size="small" status="normal" @click="bindCancel"><icon-refresh/>重置</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
  import moment from 'moment'
  import 'moment/locale/zh-cn'

  moment.locale('zh-cn')

  export default {
    name: 'FSearch',
    components: {
    },
    props: {
      superColumns: Array,
      superFilter: Object
    },
    data() {
      return {
        filter: {},
        expanded: false,
        maxVisible: 8,
        _linkChildOpts: {}
      }
    },
    computed: {
      columns() {
        let columns = {}
        for (let k in this.superColumns) {
          if (this.superColumns[k].search) {
            columns[this.superColumns[k].dataIndex] = this.superColumns[k]
          }
        }
        return columns
      },
      columnsKeyinfo() {
        const data = this.$fan.utils.parse(this.$store.state.page)
        const columns = data.columns || {}
        return columns
      },
      keyinfo() {
        const data = this.$fan.utils.parse(this.$store.state.page)
        const keyinfo = data.keyinfo || {}
        return keyinfo
      },
      options() {
        const data = this.$fan.utils.parse(this.$store.state.page)
        const options = data.options || {}
        return options
      },
      searchFields() {
        return Object.keys(this.columns)
      },
      showExpand() {
        return this.searchFields.length > this.maxVisible
      },
      searchExtras() {
        if (!this.showExpand || this.expanded) return {}
        const extras = {}
        this.searchFields.slice(this.maxVisible).forEach(f => { extras[f] = true })
        return extras
      },
    },
    async mounted() {
      // console.log('', this.columns)
      this.filter = await this.recombineDataByUserToForm(this.columnsKeyinfo)
      // console.log(this.filter)
    },
    methods: {
      moment,
      toggleExpand() {
        this.expanded = !this.expanded
      },
      /* linkSelect 搜索：一级扁平选项 */
      flatOptions(field) {
        return this.options && this.options[field] || []
      },
      /* linkSelect 搜索：一级变化时加载二级 */
      onLinkSearchChange(field, val) {
        const key = '_link_' + field
        delete this.filter[key]
        if (!val) { this._linkChildOpts = {}; return }
        const raw = this.keyinfo && this.keyinfo['__raw_' + field]
        if (!raw || !Array.isArray(raw)) return
        const collect = (arr, tid) => {
          let r = []
          arr.forEach(it => {
            if (String(it.pid) === String(tid)) r.push({ value: String(it.id), label: it.name || '' })
            if (it.children && it.children.length) r = r.concat(collect(it.children, tid))
          })
          return r
        }
        this._linkChildOpts = { ...this._linkChildOpts, [field]: collect(raw, String(val)) }
      },
      /* 将 {label,value,children} 转为 a-tree-select 需要的 {title,key,children}
         linkSelect 则从 keyinfo.__raw_ 读取原始树形数据 */
      treeSelectData(field) {
        const col = (this.superColumns || []).find(c => c.dataIndex === field)
        let src = this.options && this.options[field]
        // linkSelect：优先从 __raw_ 原始树形数据构建
        if (col && col.form === 'linkSelect') {
          const raw = this.keyinfo && this.keyinfo['__raw_' + field]
          if (raw && Array.isArray(raw) && raw.length) {
            src = raw
          }
        }
        if (!src) return []
        const arr = Array.isArray(src) ? src : Object.values(src).filter(v => v && typeof v === 'object')
        const convert = node => {
          if (!node) return null
          const item = { key: node.value ?? node.id, title: node.label ?? node.name ?? '' }
          if (node.children && node.children.length) {
            item.children = (Array.isArray(node.children) ? node.children : Object.values(node.children)).map(convert).filter(Boolean)
          }
          return item
        }
        return arr.map(convert).filter(Boolean)
      },
      bindSubmit() {
        let filter = this.$fan.utils.parse(this.filter)
        let newFilter = {}
        for(let k in filter) {
          const v = filter[k]
          // _link_ 前缀映射到真实的 linkField 名称
          const realK = k.startsWith('_link_') ? (this.columns[k.replace('_link_','')]||{}).linkField : k
          const finalK = realK || k
          if (v!=="" && v!==[] && v!=={}) {
            if (v.constructor === Array) {
              newFilter[finalK] = v[v.length-1]
            } else {
              if (this.columns[finalK] && this.columns[finalK].form == 'monthpicker') {
                newFilter[finalK] = moment(v).format('YYYY-MM')
              } else if (this.columns[finalK] && this.columns[finalK].form == 'yearpicker') {
                newFilter[finalK] = moment(v).format('YYYY')
              } else {
                newFilter[finalK] = v
              }
            }
          }
        }
        this.$emit('change', newFilter)
      },
      bindCancel() {
        this._linkChildOpts = {}
        this.filter = {}
        this.$emit('reloadData')
      },
      // 重组基于用户信息的默认数据
      async recombineDataByUserToForm(columns) {
        const keyinfo = this.$fan.utils.parse(this.keyinfo)
        let filter = {}
        // 修改id_entity
        const userInfo = this.$store.state.user
        if (userInfo.id_auth_role>1 && userInfo.id_entity) {
          let field = false
          if (columns.hasOwnProperty('id_entity')) {
            field = 'id_entity'
          } else if (columns.hasOwnProperty('id_entity_xiaofang')) {
            field = 'id_entity_xiaofang'
          } else if (columns.hasOwnProperty('id_base_org')) {
            field = 'id_base_org'
          }
          if (field) {
            filter[field] = keyinfo[field][userInfo.id_entity].value
          }
        }
        return filter
      },
      // 级联菜单搜索
      bindSearchCascader(inputValue, path) {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1))
      },
    }
  }
</script>
